<template>
  <div class="Backend-container">
    <div class="topbar">
      <TopBar :imgsrc="logo" color="#000" :islogo2="true" />
      <p>企业数据资源市场</p>
    </div>
    <div class="content">
      <div class="content-box">
        <div class="left-column">
          <div class="tree-box" v-for="(item, index) in leftList" :key="index">
            <div class="tree-box-span">
              <img :src="item.titleobj.icon" alt="" />
              <p>{{ item.titleobj.title }}</p>
            </div>
            <div
              :class="[it.istrue ? 'tree-box-li active' : 'tree-box-li']"
              v-for="(it, i) in item.list"
              :key="i"
              @click="handleclick(index, i)"
            >
              <img :src="it.icon" alt="" />
              <span>{{ it.title }}</span>
            </div>
          </div>
          <div class="exitbtn-box" @click="dialogVisible = true">
            <img :src="exiticon" alt="" />
            <p>退出登录</p>
          </div>
        </div>
        <div class="right-column">
          <router-view />
        </div>
      </div>
    </div>
    <div class="Dialogbox" v-if="dialogVisible">
      <div class="Dialog">
        <div class="Dialog-head">
          <img :src="warningIcon" alt="" />
          <p>企业数据资源市场</p>
        </div>
        <div class="Dialog-message">
          <p>确认要退出登录吗?</p>
        </div>
        <div class="Dialog-btnList">
          <button class="Cancel" @click="handlebtn">取消</button>
          <button class="Confirm" @click="handlebtnOk">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopBar from "@/views/supermarket/TopBar";
import { Message } from "element-ui";
import logo from "@/assets1/logo_slices/编组 2(1).png";
import icon3 from "@/assets1/后台/编组 3.png"
import icon4 from "@/assets1/后台/日历.png"
import icon1 from "../../assets1/已发布数据集-已选_slices/编组 10.png";
import exiticon from "../../assets1/已发布数据集-已选_slices/关闭.png";
import warningIcon from "../../assets1/已发布数据集-已选_slices/音频备份 3.png";
import icon2 from "../../assets1/已发布数据集-已选_slices/编组 12.png";
import file from "@/assets1/后台/file.png"
import userMannger from "@/assets1/后台/userMannger.png"
import user from "@/assets1/后台/user.png"
import set from "@/assets1/后台/set.png"
import password from "@/assets1/后台/password.png"
import {LoginOut} from '@/api/user.js'
export default {
  components: { TopBar },
  data() {
    return {
      dialogVisible: false,
      logo,
      password,
      user,
      set,
      userMannger,
      warningIcon,
      file,
      exiticon,
      // leftList: [
      //   {
      //     titleobj: { title: "数据需求管理", icon: icon1 },
      //     list: [
      //       {
      //         title: "我发布的需求",
      //         icon: icon2,
      //         istrue: false,
      //         path: "/Published",
      //       },
      //       {
      //         title: "发布数据需求",
      //         icon: icon2,
      //         istrue: true,
      //         path: "/release",
      //       },
      //     ],
      //   },
      //   {
      //     titleobj: { title: "用户管理", icon: icon1 },
      //     list: [
      //       {
      //         title: "修改账户信息",
      //         icon: icon2,
      //         istrue: false,
      //         path: "/updataUser",
      //       },
          
      //       {
      //         title: "修改密码",
      //         icon: icon2,
      //         istrue: false,
      //         path: "/updataPassword",
      //       },
      //       {
      //         title: "修改登录手机号",
      //         icon: icon2,
      //         istrue: false,
      //         path: "/uploadUser",
      //       },
      //     ],
      //   },
      // ],
    };
  },
  computed:{
    leftList(){
      // console.log(this.$store.state.type,'this.$store.state.type');
      if(this.$store.state.type!==null){
        console.log(this.$store.state.type,'this.$store.state.type');
        if(this.$store.state.type===1){
        return  [
        {
          titleobj: { title: "数据需求管理", icon: icon1 },
          list: [
            {
              title: "我发布的需求",
              icon: file,
              istrue: false,
              path: "/Published",
            },
            {
              title: "发布数据需求",
              icon: icon2,
              istrue: true,
              path: "/release",
            },
          ],
        },
        {
          titleobj: { title: "用户管理", icon: userMannger },
          list: [
            {
              title: "修改账户信息",
              icon: user,
              istrue: false,
              path: "/updataUser",
            },
          
            {
              title: "修改密码",
              icon: password,
              istrue: false,
              path: "/updataPassword",
            },
            {
              title: "修改登录手机号",
              icon: set,
              istrue: false,
              path: "/uploadUser",
            },
          ],
        },
      ]
      }else if(this.$store.state.type===2){
        return [
        {
          titleobj: { title: "数据需求管理", icon: icon1 },
          list: [
            {
              title: "我发布的需求",
              icon: file,
              istrue: false,
              path: "/Published",
            },
            {
            
              title: "我收到的需求",
              icon: icon3,
              istrue: false,
              path: "/requestsReceived",
            
            },
            {
              title: "发布数据需求",
              icon: icon2,
              istrue: true,
              path: "/release",
            },
          ],
        },
        {
          titleobj: { title: "数据资源管理", icon: icon1 },
          list: [
            {
              title: "我发布的数据资源",
              icon: icon3,
              istrue: false,
              path: "/Published",
              disabled:true
            },
            {
              title: "发布数据资源",
              icon: icon2,
              istrue: false,
              path: "/release",
              disabled:true
            },
          ],
        },
        {
          titleobj: { title: "用户管理", icon: userMannger },
          list: [
            {
              title: "修改账户信息",
              icon: user,
              istrue: false,
              path: "/updataUser",
            },
          
            {
              title: "修改密码",
              icon: password,
              istrue: false,
              path: "/updataPassword",
            },
            {
              title: "修改登录手机号",
              icon: set,
              istrue: false,
              path: "/uploadUser",
            },
          ],
        },
        ]

      }
      else if(this.$store.state.type===3){
        return [
        {
          titleobj: { title: "数据需求管理", icon: icon1 },
          list: [
            {
              title: "原始需求列表",
              icon: icon3,
              istrue: false,
              path: "/Published",
            },
            {
              title: "我发布数据需求",
              icon: file,
              istrue: false,
              path: "/MyPostData",
            },
            {
              title: "发布数据需求",
              icon: icon2,
              istrue: true,
              path: "/release",
            },
          ],
         
        },
        {
          titleobj: { title: "数据资源管理", icon: icon1 },
          list: [
            {
              title: "已发布的数据资源",
              icon: file,
              istrue: false,
              path: "/DataSetsList",
              disabled:true
            },
            {
              title: "发布数据资源",
              icon: icon2,
              istrue: false,
              path: "/UpLoadDataSet",
              disabled:true
            },
          ],
        },
        {
          titleobj: { title: "用户管理", icon: userMannger },
          list: [
            {
              title: "管理平台用户",
              icon: icon4,
              istrue: false,
              path: "/ManageUsers",
            },
          
            {
              title: "修改密码",
              icon: password,
              istrue: false,
              path: "/updataPassword",
            },
            {
              title: "修改登录手机号",
              icon: set,
              istrue: false,
              path: "/uploadUser",
            },
          ],
        },
        ]

      }
      }
    
    }
  },
  methods: {
    handleclick(index, i) {
  if(this.leftList){
    this.leftList.forEach((item) => {
        item.list.forEach((it) => {
          it.istrue = false;
        });
      });
      if(this.leftList[index].list[i].disabled){
        Message({
        message: "暂未开放",
        type: "warning",
      });
      
      return
      }
      this.leftList[index].list[i].istrue = true;
      //    console.log(this.$route.path);
      if (this.$route.path === this.leftList[index].list[i].path) {
        return;
      }
      this.$router.push(this.leftList[index].list[i].path);
  }
    },
    handlebtn() {
      this.dialogVisible = false;
    },
   async handlebtnOk(){
      this.dialogVisible = false;

      const res=await LoginOut()
      this.$store.commit('setUserInfo',null)
      console.log(res);
     await sessionStorage.removeItem('token')
  await localStorage.removeItem('token')
      
      this.$router.push('/Dataset')
    }
  },
  created() {
    this.leftList.forEach((item) => {
      item.list.forEach((it) => {
        if (it.istrue) {
          if (this.$route.path === it.path) {
            return;
          }
          this.$router.push(it.path);
        }
      });
    });
  },
  watch:{
    '$store.state.type':{
      handler(newVal){
        // this.$forceUpdate(); 
        console.log(newVal,'newVal');
      },
    }
  }
};
</script>

<style scoped>
.Confirm {
  background-color: #0d53ff;
  color: #fff;
}
.Cancel {
  background-color: #fff;
  color: #999;
}
.Dialog-btnList {
  position: absolute;
  bottom: 40px;
  right: 40px;
}
.Dialog-btnList button {
  width: 65px;
  height: 35px;
  border-radius: 4px;
  font-size: 14px;
  margin-right: 15px;
  outline: none;
  border: 1px solid #d9d9d9;
  letter-spacing: 2px;
  cursor: pointer;
}
.Dialog-message {
  color: #666666;
  font-size: 18px;
  margin-top: 20px;
  margin-left: 40px;
}
.Dialog-head {
  display: flex;
  font-family: Medium;
  font-size: 21px;
  line-height: 28px;
}
.Dialog-head img {
  width: 28px;
  height: 28px;
  object-fit: cover;
  margin-right: 14px;
}
.Dialog {
  width: 416px;
  height: 228px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  border-radius: 12px;
  padding: 40px;
}
.Dialogbox {
  z-index: 100;
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: rgba(34, 34, 34, 0.6);
}
.exitbtn-box img {
  width: 18px;
  height: 18px;
  margin-right: 8px;
  margin-left: 35px;
}
.exitbtn-box {
  width: 100%;
  position: absolute;
  font-size: 14px;
  display: flex;
  color: #e92424;
  bottom: 20px;
  left: 0;
  line-height: 18px;
  cursor: pointer;
}
.active::before {
  content: "";
  position: absolute;
  height: 100%;
  left: 0;
  width: 4px;
  background-color: #1c66ed;
  left: 0;
}
.active {
  position: relative;
  background-color: rgba(13, 83, 255, 0.08);
}
.tree-box-span {
  display: flex;
  font-size: 14px;
  line-height: 18px;
  font-family: Regular;
  color: #999999;
  height: 56px;

  align-items: center;
}
.tree-box-span img {
  width: 18px;
  height: 18px;
  margin-left: 35px;
  margin-right: 8px;
}
.tree-box-li {
  display: flex;
  font-size: 14px;
  line-height: 18px;
  font-family: Regular;
  color: #000;
  height: 56px;
  cursor: pointer;

  align-items: center;
}
.tree-box-li img {
  width: 18px;
  height: 18px;
  margin-left: 35px;
  margin-right: 8px;
}

.content-box {
  margin-top: 16px;
  display: flex;
}
.right-column {
width: 964px;
  min-height: 794px;
  background-color: #fff;
  border-radius: 12px;
  padding-bottom: 50px;
}
.left-column {
  padding-top: 20px;
  width: 220px;
  height: 794px;
  background-color: #fff;
  border-radius: 12px;
  margin-right: 16px;
  position: relative;
}
.Backend-container {
  min-width: 1920px;
  min-height: 1080px;
  display: flex;
  flex-direction: column;
  position: relative;
}
.topbar {
min-width: 1920px;
  height: 220px;
  background-image: url("../../assets1/已发布数据集-已选_slices/位图.png");
}
.topbar p {
  font-family: Heavy;
  line-height: 52px;
  color: black;
  font-size: 38px;
  padding-left: 492px;
  padding-top: 104px;
}
.content {
width: 100%;

  display: flex;
  justify-content: center;
  flex-grow: 1;
  background-color: #f7f8fc;
  flex-shrink: 0;
}
</style>